"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validZipcodesWithLabels = exports.validZipcodes = exports.isZipcodeCovered = exports.getZipcodesBySubZoneName = exports.checkError = void 0;
var _zones = require("./zones");
var _countries = _interopRequireWildcard(require("../countries"));
var _utils = require("./utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var getZipcodesBySubZoneName = exports.getZipcodesBySubZoneName = function getZipcodesBySubZoneName(subZoneName) {
  var allSubZones = _zones.zones.flatMap(function (zone) {
    return zone.subZones;
  });
  var matchingSubZone = allSubZones.find(function (subZone) {
    return subZone.name === subZoneName;
  });
  if (!matchingSubZone) {
    var matchingOldSubZone = (0, _utils.getOldSubZoneName)(subZoneName);
    matchingSubZone = allSubZones.find(function (subZone) {
      return subZone.name === matchingOldSubZone;
    });
    if (!matchingSubZone) {
      var matchingNewSubZone = (0, _utils.getNewSubZoneName)(subZoneName);
      matchingSubZone = allSubZones.find(function (subZone) {
        return subZone.name === matchingNewSubZone;
      });
      if (!matchingSubZone) {
        throw new Error("Sous-zone \"".concat(subZoneName, "\" non trouv\xE9e"));
      }
    }
  }
  return Object.keys(matchingSubZone.zipcodes);
};
var validZipcodes = exports.validZipcodes = _zones.zones.filter(function (zone) {
  return ['BE', 'FR'].includes(zone.country);
}).flatMap(function (zone) {
  return zone.subZones;
}).reduce(function (currentZipcodes, subZone) {
  return currentZipcodes.concat(Object.keys(subZone.zipcodes));
}, []);
var validZipcodesWithLabels = exports.validZipcodesWithLabels = _zones.zones.flatMap(function (zone) {
  return zone.subZones;
}).reduce(function (acc, currentSubZone) {
  var zipcodes = currentSubZone.zipcodes;
  Object.keys(zipcodes).forEach(function (zipcode) {
    acc.push({
      zipcode: zipcode,
      label: zipcodes[zipcode].label
    });
  });
  return acc;
}, []);

/**
 * @deprecated
 * @see Country.zipcodeChecker
 * @see Country.zipcodeMatcher
 */
var isZipcodeCovered = exports.isZipcodeCovered = function isZipcodeCovered(zipcode) {
  return validZipcodes.includes(zipcode);
};
var checkError = exports.checkError = function checkError(zipcode) {
  var countryCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _countries.DEFAULT_COUNTRY;
  var country = (0, _countries["default"])(function (str) {
    return str;
  }).find(function (countryRegistered) {
    return countryRegistered.id === countryCode;
  });
  if (country !== null && country !== void 0 && country.zipcodeChecker(zipcode)) {
    if (!validZipcodes.includes(zipcode)) {
      return {
        message: 'Votre ville n’est pas encore couverte par notre service. Nous desservons la plupart des grandes villes en France comme Paris et une partie de l‘Ile-de-France, Marseille, Lyon, Bordeaux, Aix-en-Provence, Toulouse, Lille, Nice.',
        // eslint-disable-line max-len
        code: 2
      };
    }
    return {
      message: '',
      code: 0
    };
  }
  return {
    message: 'Oups, il semble que ce code postal ne soit pas valide.',
    code: 1
  };
};